import { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const LanguageSwitcher = ({ variant = "desktop" }) => {
  const { language, setLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  if (variant === "mobile") {
    return (
      <div data-testid="language-switcher-mobile" className="flex items-center gap-2">
        {languages.map((lang) => (
          <button
            key={lang.code}
            data-testid={`language-switcher-option-mobile-${lang.code}`}
            onClick={() => setLanguage(lang.code)}
            className={`text-xs font-bold px-3 py-1.5 rounded-full border transition-colors duration-200 ${
              language === lang.code ? "bg-white text-black border-white" : "border-white/20 text-neutral-400"
            }`}
          >
            {lang.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div ref={ref} className="relative">
      <button
        data-testid="language-switcher-button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-1.5 text-[13px] font-semibold text-neutral-300 hover:text-white transition-colors duration-200 px-2 py-1.5"
      >
        <Globe className="w-3.5 h-3.5" />
        {language.toUpperCase()}
        <ChevronDown className={`w-3 h-3 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div data-testid="language-switcher-menu" className="absolute right-0 top-full mt-2 rounded-xl border border-white/10 bg-[#141415] shadow-[0_20px_40px_-10px_rgba(0,0,0,0.8)] overflow-hidden min-w-[140px] z-50">
          {languages.map((lang) => (
            <button
              key={lang.code}
              data-testid={`language-switcher-option-${lang.code}`}
              onClick={() => { setLanguage(lang.code); setOpen(false); }}
              className={`w-full text-left px-4 py-2.5 text-sm flex items-center justify-between gap-2 transition-colors duration-150 ${
                language === lang.code ? "text-white bg-white/[0.06]" : "text-neutral-400 hover:text-white hover:bg-white/[0.04]"
              }`}
            >
              <span>{lang.name}</span>
              <span className="text-[11px] text-neutral-500">{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
